export default function (sortOrder) {
  return (value, nextValue) => {
    if (value === nextValue) return 0;

    if (!value) return nextValue ? 1 : 0;
    if (!nextValue) return -1;

    let first = JSON.parse(value);
    let next = JSON.parse(nextValue);
    if (!first) return next ? 1 : 0;
    if (!next) return -1;

    if (first.data && Object.keys(first.data).includes('sort-value')) {
      first = first.data['sort-value'];
    } else {
      first = first.text;
    }

    if (next.data && Object.keys(next.data).includes('sort-value')) {
      next = next.data['sort-value'];
    } else {
      next = next.text;
    }

    if (first < next) return sortOrder === 'asc' ? -1 : 1;
    if (first > next) return sortOrder === 'asc' ? 1 : -1;

    return 0;
  };
}
